/**
 * @file Re-exports the authenticator setup component.
 */
import TotpSetup from "./TotpSetup";

export default TotpSetup;
